

export default {
  table_check:[],  // 表格屏蔽列
}


// WEBPACK FOOTER //
// ./src/store/state.js